export const imports = {
  'docs/pages/index.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-index" */ 'docs/pages/index.mdx'
    ),
  'docs/pages/about/changelog.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-about-changelog" */ 'docs/pages/about/changelog.mdx'
    ),
  'docs/pages/about/ci-cd.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-about-ci-cd" */ 'docs/pages/about/ci-cd.mdx'
    ),
  'docs/pages/about/licence.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-about-licence" */ 'docs/pages/about/licence.mdx'
    ),
  'docs/pages/errors-pages/errors-pages.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-errors-pages-errors-pages" */ 'docs/pages/errors-pages/errors-pages.mdx'
    ),
  'docs/pages/guides/SCSS-code-guidelines.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-guides-scss-code-guidelines" */ 'docs/pages/guides/SCSS-code-guidelines.mdx'
    ),
  'docs/pages/guides/atomic-design.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-guides-atomic-design" */ 'docs/pages/guides/atomic-design.mdx'
    ),
  'docs/pages/getting-started/installation.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-getting-started-installation" */ 'docs/pages/getting-started/installation.mdx'
    ),
  'docs/pages/ui-projects/instanceQuickview.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-projects-instance-quickview" */ 'docs/pages/ui-projects/instanceQuickview.mdx'
    ),
  'docs/pages/ui-projects/map-interaction.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-projects-map-interaction" */ 'docs/pages/ui-projects/map-interaction.mdx'
    ),
  'docs/pages/ui-projects/project-instances-quickview.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-projects-project-instances-quickview" */ 'docs/pages/ui-projects/project-instances-quickview.mdx'
    ),
  'docs/pages/ui-projects/status.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-projects-status" */ 'docs/pages/ui-projects/status.mdx'
    ),
  'docs/pages/ui-projects/pipeline.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-projects-pipeline" */ 'docs/pages/ui-projects/pipeline.mdx'
    ),
  'docs/pages/ui-formsy/field-check.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-field-check" */ 'docs/pages/ui-formsy/field-check.mdx'
    ),
  'docs/pages/ui-formsy/field-codemirror.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-field-codemirror" */ 'docs/pages/ui-formsy/field-codemirror.mdx'
    ),
  'docs/pages/ui-formsy/field-input.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-field-input" */ 'docs/pages/ui-formsy/field-input.mdx'
    ),
  'docs/pages/ui-formsy/field-password.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-field-password" */ 'docs/pages/ui-formsy/field-password.mdx'
    ),
  'docs/pages/ui-formsy/field-select.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-field-select" */ 'docs/pages/ui-formsy/field-select.mdx'
    ),
  'docs/pages/ui-formsy/field-slider.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-field-slider" */ 'docs/pages/ui-formsy/field-slider.mdx'
    ),
  'docs/pages/ui-formsy/field-textarea.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-field-textarea" */ 'docs/pages/ui-formsy/field-textarea.mdx'
    ),
  'docs/pages/ui-formsy/form-multi-steps.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-form-multi-steps" */ 'docs/pages/ui-formsy/form-multi-steps.mdx'
    ),
  'docs/pages/ui-formsy/introduction.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-formsy-introduction" */ 'docs/pages/ui-formsy/introduction.mdx'
    ),
  'docs/pages/visual-style/assets.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-visual-style-assets" */ 'docs/pages/visual-style/assets.mdx'
    ),
  'docs/pages/visual-style/colors.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-visual-style-colors" */ 'docs/pages/visual-style/colors.mdx'
    ),
  'docs/pages/visual-style/shadow.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-visual-style-shadow" */ 'docs/pages/visual-style/shadow.mdx'
    ),
  'docs/pages/visual-style/typography.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-visual-style-typography" */ 'docs/pages/visual-style/typography.mdx'
    ),
  'docs/pages/ui-core/atoms/add-placeholder.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-add-placeholder" */ 'docs/pages/ui-core/atoms/add-placeholder.mdx'
    ),
  'docs/pages/ui-core/atoms/avatar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-avatar" */ 'docs/pages/ui-core/atoms/avatar.mdx'
    ),
  'docs/pages/ui-core/atoms/badge.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-badge" */ 'docs/pages/ui-core/atoms/badge.mdx'
    ),
  'docs/pages/ui-core/atoms/button.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-button" */ 'docs/pages/ui-core/atoms/button.mdx'
    ),
  'docs/pages/ui-core/atoms/form-check.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-check" */ 'docs/pages/ui-core/atoms/form-check.mdx'
    ),
  'docs/pages/ui-core/atoms/form-control-input.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-control-input" */ 'docs/pages/ui-core/atoms/form-control-input.mdx'
    ),
  'docs/pages/ui-core/atoms/form-control-select.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-control-select" */ 'docs/pages/ui-core/atoms/form-control-select.mdx'
    ),
  'docs/pages/ui-core/atoms/form-feedback.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-feedback" */ 'docs/pages/ui-core/atoms/form-feedback.mdx'
    ),
  'docs/pages/ui-core/atoms/form-helper.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-helper" */ 'docs/pages/ui-core/atoms/form-helper.mdx'
    ),
  'docs/pages/ui-core/atoms/form-label.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-label" */ 'docs/pages/ui-core/atoms/form-label.mdx'
    ),
  'docs/pages/ui-core/atoms/form-options-group.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-options-group" */ 'docs/pages/ui-core/atoms/form-options-group.mdx'
    ),
  'docs/pages/ui-core/atoms/form-password.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-password" */ 'docs/pages/ui-core/atoms/form-password.mdx'
    ),
  'docs/pages/ui-core/atoms/form-range.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-form-range" */ 'docs/pages/ui-core/atoms/form-range.mdx'
    ),
  'docs/pages/ui-core/atoms/icon.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-icon" */ 'docs/pages/ui-core/atoms/icon.mdx'
    ),
  'docs/pages/ui-core/atoms/info-text.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-info-text" */ 'docs/pages/ui-core/atoms/info-text.mdx'
    ),
  'docs/pages/ui-core/atoms/label-value.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-label-value" */ 'docs/pages/ui-core/atoms/label-value.mdx'
    ),
  'docs/pages/ui-core/atoms/loader.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-loader" */ 'docs/pages/ui-core/atoms/loader.mdx'
    ),
  'docs/pages/ui-core/atoms/logline.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-logline" */ 'docs/pages/ui-core/atoms/logline.mdx'
    ),
  'docs/pages/ui-core/atoms/paper.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-paper" */ 'docs/pages/ui-core/atoms/paper.mdx'
    ),
  'docs/pages/ui-core/atoms/progress-bar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-progress-bar" */ 'docs/pages/ui-core/atoms/progress-bar.mdx'
    ),
  'docs/pages/ui-core/atoms/step-indicator.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-step-indicator" */ 'docs/pages/ui-core/atoms/step-indicator.mdx'
    ),
  'docs/pages/ui-core/atoms/technology-badge.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-technology-badge" */ 'docs/pages/ui-core/atoms/technology-badge.mdx'
    ),
  'docs/pages/ui-core/atoms/text.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-text" */ 'docs/pages/ui-core/atoms/text.mdx'
    ),
  'docs/pages/ui-core/atoms/thumbnail.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-thumbnail" */ 'docs/pages/ui-core/atoms/thumbnail.mdx'
    ),
  'docs/pages/ui-core/atoms/time-display.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-time-display" */ 'docs/pages/ui-core/atoms/time-display.mdx'
    ),
  'docs/pages/ui-core/atoms/time-from-now.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-time-from-now" */ 'docs/pages/ui-core/atoms/time-from-now.mdx'
    ),
  'docs/pages/ui-core/atoms/tooltip.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-atoms-tooltip" */ 'docs/pages/ui-core/atoms/tooltip.mdx'
    ),
  'docs/pages/ui-core/grid/grid.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-grid-grid" */ 'docs/pages/ui-core/grid/grid.mdx'
    ),
  'docs/pages/ui-core/hooks/hooks.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-hooks-hooks" */ 'docs/pages/ui-core/hooks/hooks.mdx'
    ),
  'docs/pages/ui-core/helpers/clickawaylistener.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-helpers-clickawaylistener" */ 'docs/pages/ui-core/helpers/clickawaylistener.mdx'
    ),
  'docs/pages/ui-core/helpers/display.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-helpers-display" */ 'docs/pages/ui-core/helpers/display.mdx'
    ),
  'docs/pages/ui-core/helpers/margin.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-helpers-margin" */ 'docs/pages/ui-core/helpers/margin.mdx'
    ),
  'docs/pages/ui-core/helpers/padding.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-helpers-padding" */ 'docs/pages/ui-core/helpers/padding.mdx'
    ),
  'docs/pages/ui-core/helpers/text.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-helpers-text" */ 'docs/pages/ui-core/helpers/text.mdx'
    ),
  'docs/pages/ui-core/layouts/app-layout.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-layouts-app-layout" */ 'docs/pages/ui-core/layouts/app-layout.mdx'
    ),
  'docs/pages/ui-core/layouts/container.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-layouts-container" */ 'docs/pages/ui-core/layouts/container.mdx'
    ),
  'docs/pages/ui-core/layouts/first-level-nav.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-layouts-first-level-nav" */ 'docs/pages/ui-core/layouts/first-level-nav.mdx'
    ),
  'docs/pages/ui-core/layouts/offline-splitted.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-layouts-offline-splitted" */ 'docs/pages/ui-core/layouts/offline-splitted.mdx'
    ),
  'docs/pages/ui-core/layouts/page-header.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-layouts-page-header" */ 'docs/pages/ui-core/layouts/page-header.mdx'
    ),
  'docs/pages/ui-core/layouts/page.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-layouts-page" */ 'docs/pages/ui-core/layouts/page.mdx'
    ),
  'docs/pages/ui-core/layouts/second-level-nav.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-layouts-second-level-nav" */ 'docs/pages/ui-core/layouts/second-level-nav.mdx'
    ),
  'docs/pages/ui-core/layouts/topbar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-layouts-topbar" */ 'docs/pages/ui-core/layouts/topbar.mdx'
    ),
  'docs/pages/ui-core/molecules/add-box.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-add-box" */ 'docs/pages/ui-core/molecules/add-box.mdx'
    ),
  'docs/pages/ui-core/molecules/avatar-stack.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-avatar-stack" */ 'docs/pages/ui-core/molecules/avatar-stack.mdx'
    ),
  'docs/pages/ui-core/molecules/breadcrumb.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-breadcrumb" */ 'docs/pages/ui-core/molecules/breadcrumb.mdx'
    ),
  'docs/pages/ui-core/molecules/callout.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-callout" */ 'docs/pages/ui-core/molecules/callout.mdx'
    ),
  'docs/pages/ui-core/molecules/card.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-card" */ 'docs/pages/ui-core/molecules/card.mdx'
    ),
  'docs/pages/ui-core/molecules/empty-state.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-empty-state" */ 'docs/pages/ui-core/molecules/empty-state.mdx'
    ),
  'docs/pages/ui-core/molecules/form-group.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-form-group" */ 'docs/pages/ui-core/molecules/form-group.mdx'
    ),
  'docs/pages/ui-core/molecules/form-list.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-form-list" */ 'docs/pages/ui-core/molecules/form-list.mdx'
    ),
  'docs/pages/ui-core/molecules/logs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-logs" */ 'docs/pages/ui-core/molecules/logs.mdx'
    ),
  'docs/pages/ui-core/molecules/media-objects.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-media-objects" */ 'docs/pages/ui-core/molecules/media-objects.mdx'
    ),
  'docs/pages/ui-core/molecules/messages.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-messages" */ 'docs/pages/ui-core/molecules/messages.mdx'
    ),
  'docs/pages/ui-core/molecules/search-bar.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-search-bar" */ 'docs/pages/ui-core/molecules/search-bar.mdx'
    ),
  'docs/pages/ui-core/molecules/search-empty-state.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-search-empty-state" */ 'docs/pages/ui-core/molecules/search-empty-state.mdx'
    ),
  'docs/pages/ui-core/molecules/tabs.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-molecules-tabs" */ 'docs/pages/ui-core/molecules/tabs.mdx'
    ),
  'docs/pages/ui-core/organisms/accordion.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-accordion" */ 'docs/pages/ui-core/organisms/accordion.mdx'
    ),
  'docs/pages/ui-core/organisms/confirm.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-confirm" */ 'docs/pages/ui-core/organisms/confirm.mdx'
    ),
  'docs/pages/ui-core/organisms/datalist.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-datalist" */ 'docs/pages/ui-core/organisms/datalist.mdx'
    ),
  'docs/pages/ui-core/organisms/date-picker.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-date-picker" */ 'docs/pages/ui-core/organisms/date-picker.mdx'
    ),
  'docs/pages/ui-core/organisms/dropdown.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-dropdown" */ 'docs/pages/ui-core/organisms/dropdown.mdx'
    ),
  'docs/pages/ui-core/organisms/listSearchFilters.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-list-search-filters" */ 'docs/pages/ui-core/organisms/listSearchFilters.mdx'
    ),
  'docs/pages/ui-core/organisms/modal.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-modal" */ 'docs/pages/ui-core/organisms/modal.mdx'
    ),
  'docs/pages/ui-core/organisms/page-popin.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-page-popin" */ 'docs/pages/ui-core/organisms/page-popin.mdx'
    ),
  'docs/pages/ui-core/organisms/popup.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-popup" */ 'docs/pages/ui-core/organisms/popup.mdx'
    ),
  'docs/pages/ui-core/organisms/notification.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-notification" */ 'docs/pages/ui-core/organisms/notification.mdx'
    ),
  'docs/pages/ui-core/organisms/side-panel.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-side-panel" */ 'docs/pages/ui-core/organisms/side-panel.mdx'
    ),
  'docs/pages/ui-core/organisms/transfer-datalist.mdx': () =>
    import(
      /* webpackPrefetch: true, webpackChunkName: "docs-pages-ui-core-organisms-transfer-datalist" */ 'docs/pages/ui-core/organisms/transfer-datalist.mdx'
    ),
}
